import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CircleCheck, MessageCircle, Headset, Sparkles, ArrowUpRight, Bot, Ticket, User } from 'lucide-react';
import { PRODUCTS } from '../mock';
import { Button } from './ui/button';

const tabIcon = {
  conversas: MessageCircle,
  helpdesk: Headset,
  coreai: Sparkles,
};

const ProductVisual = ({ id }) => {
  if (id === 'conversas') {
    return (
      <div className="relative w-full h-full min-h-[380px] bg-gradient-to-br from-[#FFF6F0] to-[#F1EBFF] rounded-2xl p-6 overflow-hidden">
        <div className="absolute top-6 right-6 bg-white rounded-xl shadow-lg px-4 py-3 flex items-center gap-3 border border-slate-100">
          <div className="w-10 h-10 rounded-full bg-[#25D366] flex items-center justify-center text-white text-sm font-bold">W</div>
          <div>
            <div className="text-xs text-slate-400">WhatsApp</div>
            <div className="text-sm font-bold text-[#0a0e27]">Multiatendimento</div>
          </div>
        </div>
        <div className="absolute bottom-6 left-6 right-6 bg-white rounded-2xl shadow-xl p-4 border border-slate-100">
          <div className="flex items-center gap-2 mb-3">
            <div className="w-8 h-8 rounded-full bg-[#FF5B24] text-white text-xs font-bold flex items-center justify-center">JS</div>
            <div className="text-xs font-semibold text-[#0a0e27]">João Silva · WhatsApp</div>
          </div>
          <div className="space-y-2">
            <div className="bg-slate-100 rounded-xl rounded-tl-sm px-3 py-2 text-xs text-slate-700 max-w-[80%]">Quero saber sobre a Black Friday!</div>
            <div className="ml-auto bg-[#0a0e27] text-white rounded-xl rounded-tr-sm px-3 py-2 text-xs max-w-[80%] w-fit">
              Temos 40% OFF em todos os planos anuais até sexta! Quer que eu gere seu cupom?
            </div>
          </div>
        </div>
        <div className="absolute top-24 left-8 flex flex-wrap gap-1.5">
          {['WhatsApp', 'Instagram', 'Messenger', 'E-mail', 'Chat'].map((c) => (
            <span key={c} className="text-[10px] font-semibold px-2.5 py-1 rounded-full bg-white text-[#0a0e27] border border-slate-200 shadow-sm">
              {c}
            </span>
          ))}
        </div>
      </div>
    );
  }
  if (id === 'helpdesk') {
    return (
      <div className="relative w-full h-full min-h-[380px] bg-gradient-to-br from-[#F4F8FF] to-[#FFF6F0] rounded-2xl p-6 overflow-hidden">
        <div className="bg-white rounded-2xl shadow-xl border border-slate-100 overflow-hidden">
          <div className="px-4 py-3 border-b border-slate-100 flex items-center justify-between">
            <div className="font-semibold text-sm text-[#0a0e27]">Fila de Tickets</div>
            <div className="text-xs text-slate-400">Hoje · 42 abertos</div>
          </div>
          <div className="divide-y divide-slate-100">
            {[
              { id: '#4821', title: 'Erro no checkout do plano', sla: '2h', color: 'bg-emerald-100 text-emerald-700' },
              { id: '#4820', title: 'Dúvida sobre integração RD', sla: '4h', color: 'bg-amber-100 text-amber-700' },
              { id: '#4819', title: 'Solicitar segunda via de NF', sla: '1h', color: 'bg-rose-100 text-rose-700' },
              { id: '#4818', title: 'Alterar domínio do e-mail', sla: '6h', color: 'bg-emerald-100 text-emerald-700' },
            ].map((t) => (
              <div key={t.id} className="px-4 py-3 flex items-center gap-3 hover:bg-slate-50">
                <div className="w-8 h-8 rounded-lg bg-[#FFF1EA] flex items-center justify-center">
                  <Ticket size={14} className="text-[#FF5B24]" />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-semibold text-[#0a0e27]">{t.id} · {t.title}</div>
                  <div className="text-[10px] text-slate-500 mt-0.5">Atribuído a Maria B.</div>
                </div>
                <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${t.color}`}>SLA {t.sla}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
  return (
    <div className="relative w-full h-full min-h-[380px] bg-gradient-to-br from-[#0a0e27] to-[#1a1f4d] rounded-2xl p-6 overflow-hidden">
      <div className="absolute top-6 right-6 w-16 h-16 rounded-2xl bg-gradient-to-br from-[#FF5B24] to-[#ff8f5a] flex items-center justify-center shadow-2xl">
        <Bot size={30} className="text-white" />
      </div>
      <div className="mt-16 space-y-3">
        <div className="bg-white/10 backdrop-blur border border-white/10 rounded-xl px-4 py-3">
          <div className="flex items-center gap-2 mb-1">
            <User size={12} className="text-white/60" />
            <span className="text-[10px] text-white/60 font-medium">Cliente</span>
          </div>
          <div className="text-sm text-white/90">Meu pedido não chegou. Pode verificar?</div>
        </div>
        <div className="bg-[#FF5B24]/15 backdrop-blur border border-[#FF5B24]/40 rounded-xl px-4 py-3">
          <div className="flex items-center gap-2 mb-1">
            <Sparkles size={12} className="text-[#FF5B24]" />
            <span className="text-[10px] text-[#FF5B24] font-semibold">CoreAI</span>
          </div>
          <div className="text-sm text-white">Vi aqui que seu pedido #10442 saiu para entrega hoje. Previsão até 18h. Quer que eu envie o rastreio?</div>
        </div>
        <div className="grid grid-cols-3 gap-2 pt-2">
          {[{k: '24/7', v: 'Autônomo'}, {k: '87%', v: 'Resolução'}, {k: '1.2s', v: 'Resposta'}].map((s) => (
            <div key={s.k} className="bg-white/5 border border-white/10 rounded-lg p-2">
              <div className="text-lg font-black text-white">{s.k}</div>
              <div className="text-[10px] text-white/60">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const ProductTabs = () => {
  const [active, setActive] = useState(PRODUCTS[0].id);
  const product = PRODUCTS.find((p) => p.id === active);

  return (
    <section id="products" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-[11px] font-bold uppercase tracking-widest text-[#FF5B24]">O QUE A COREDESK FAZ</div>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold text-[#0a0e27]">
            A inteligência central da sua operação de atendimento
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Centralize seus canais e deixe que nossos Agentes de IA resolvam o repetitivo.
            Garanta <b className="text-[#0a0e27]">100% de respostas</b> e tempo livre para seu time vender.
          </p>
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-2">
          {PRODUCTS.map((p) => {
            const Icon = tabIcon[p.id];
            const on = active === p.id;
            return (
              <button
                key={p.id}
                onClick={() => setActive(p.id)}
                className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold transition-all ${
                  on
                    ? 'bg-[#0a0e27] text-white shadow-lg'
                    : 'bg-slate-100 text-slate-600 hover:bg-slate-200'
                }`}
              >
                <Icon size={16} />
                {p.tag}
              </button>
            );
          })}
        </div>

        <div className="mt-12 grid lg:grid-cols-2 gap-10 items-center">
          <div>
            <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#FF5B24]">
              {product.tag}
            </div>
            <h3 className="mt-3 text-3xl md:text-4xl font-extrabold text-[#0a0e27] leading-tight">
              {product.title}
            </h3>
            <p className="mt-4 text-slate-600 text-base leading-relaxed">{product.description}</p>
            <ul className="mt-6 space-y-3">
              {product.bullets.map((b) => (
                <li key={b} className="flex items-start gap-3">
                  <span className="mt-0.5 w-5 h-5 rounded-full bg-[#FFF1EA] flex items-center justify-center shrink-0">
                    <CircleCheck size={13} className="text-[#FF5B24]" />
                  </span>
                  <span className="text-sm text-slate-700">{b}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8">
              <Button asChild className="btn-coral rounded-full h-12 px-6 text-sm font-semibold gap-1.5">
                <Link to="/contato">Solicitar demonstração <ArrowUpRight size={16} /></Link>
              </Button>
            </div>
          </div>
          <ProductVisual id={product.id} />
        </div>
      </div>
    </section>
  );
};

export default ProductTabs;
